module.exports = __webpack_public_path__ + "img/doc_sem.1ceb7ba9.svg";